import { CellItemHeight } from '../constants';

export const getChangeTypeCellStyles = () => ({
  '@global': {
    '& .ChangeType.ms-DetailsRow-cell': {
      padding: 0,
    },
  },
  ChangeTypeCell: {
    width: '100%',
  },
  ChangeTypeItem: {
    width: '100%',
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 12,
    placeContent: 'center',
  },
  BorderBottomLine: {
    borderBottom: '1px solid rgb(243, 242, 241)',
  },
  [`ChangeTypeItem-${CellItemHeight.Large}`]: {
    height: 62,
  },
  [`ChangeTypeItem-${CellItemHeight.Small}`]: {
    height: 44,
  },
});
